import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { AppComponent } from './../app.component';
import { AutenticaService } from './../login/autentica.service';
import { ConfigsService } from './../configs.service';
import { Router } from '@angular/router';
declare var swal:any;
declare var $:any;

declare var $;
@Component({
  selector: 'app-topo',
  templateUrl: './topo.component.html',
  styleUrls: ['./topo.component.css']
})
export class TopoComponent implements OnInit {

  corPadrao: any;
  logo: string;
  dadosMedico:any;
  dadosHospital:any;

  @Output() public mostrarMenuEmitter = new EventEmitter<boolean>();
  
  constructor(private app:ConfigsService, private autentica:AutenticaService, private rota: Router) {
    this.logo = this.app.logo;    
    this.corPadrao = this.app.corPadrao;
    this.dadosMedico = JSON.parse(sessionStorage.getItem("autenticacao"));        
    this.dadosHospital = JSON.parse(sessionStorage.getItem("hospital"));
  }

  sair(){
    // sessionStorage.removeItem('autenticacao');
    // sessionStorage.removeItem('hospital');
    sessionStorage.clear();
    window.location.href="/"; 
  }

  ngOnInit() {        
    // console.log(this.dadosMedico);
    //toggle
    $('.navbar-toggle').on('click', function (event) {

      $(this).toggleClass('open');
      $('#navigation').slideToggle(400);
    });

    $('.navigation-menu>li').slice(-1).addClass('last-elements');

    $('.navigation-menu li.has-submenu a[href="#"]').on('click', function (e) {
      if ($(window).width() < 992) {
        e.preventDefault();
        $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
      }
    });

    $(".right-bar-toggle").click(function(){
      $(".right-bar").toggle();
      $('.wrapper').toggleClass('right-bar-enabled');
    });
  }

  async validaConselho(){
    let codigoMedicoAutenticado = JSON.parse(sessionStorage.getItem("autenticacao")).codigo;		
    let conselhoMedicoAutenticado = JSON.parse(sessionStorage.getItem("autenticacao")).sigla;		
    let valida = await this.app.validaConselho(codigoMedicoAutenticado, conselhoMedicoAutenticado)
    if(valida  >= 2){
        this.rota.navigate(["/dietas/cadastrar"])      
    }else{
      // caso o conselho não seja Médico ou nutricionista
      swal("Oops.", "Usuário sem permissão realizar esta ação.", "info")
      .then(retorno => {
        this.rota.navigate(["/"])
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/topo/topo.component.ts